/* istanbul ignore file */
export { default } from './PageMainCard';
